import { FldrObjectWrapper } from '../../shared/wrappers/fldrobject.wrapper';
import { CommonEnums } from '../../shared/common.enums';

export class Repository {
    private static instance: Repository;

    static getInstance() {
        if (!Repository.instance) {
            Repository.instance = new Repository();
        }
        return Repository.instance;
    }

    fldrObjectWrappersMap: Map<number, FldrObjectWrapper>;
    fldrObjectWrapper: FldrObjectWrapper;

    change_Ind: string;

    /**
     * Repository is a singleton class, so use Repository.getInstance() method instead of creating new Repository().
     */
    private constructor() {
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    }

    setChange_Ind(): void {
        let isModified: boolean = false;
        this.fldrObjectWrappersMap.forEach((fldrObjectWrapper: FldrObjectWrapper, obj_Id: number) => {
            fldrObjectWrapper.fldrObject.setChange_Ind();

            if (fldrObjectWrapper.change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.change_Ind = CommonEnums.change_Ind.CHANGED;
                isModified = true;
                return;
            }
        });

        if (!isModified) {
            this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        }
    }
}